import { render, staticRenderFns } from "./action-bar-item.vue?vue&type=template&id=40a056f8&"
import script from "./action-bar-item.vue?vue&type=script&lang=ts&"
export * from "./action-bar-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a056f8')) {
      api.createRecord('40a056f8', component.options)
    } else {
      api.reload('40a056f8', component.options)
    }
    module.hot.accept("./action-bar-item.vue?vue&type=template&id=40a056f8&", function () {
      api.rerender('40a056f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/action-bar/action-bar-item.vue"
export default component.exports